import {Config} from "./config";

export default {
    SSO_AUTH_CONFIG_TENANT_NAME: 'oplprod',
    SSO_AUTH_CONFIG_CLIENT_ID: '322b9c67-e77d-4823-83ed-dba6a5484390',
    ENABLE_FEATURE: true,
    API_HOST: "/tooling",
    AUTH0_DOMAIN: 'oaktreepower.uk.auth0.com',
    AUTH0_CLIENT_ID: '6wmbr4RdhJia3hoS6ZQjJdVJwCL9pTCp',
} as Config;